import React__default from 'react';
import PropTypes from 'prop-types';
import { ToggleWrapper, StyledBG, StyledLeft, StyledRight, StyledHandle } from './styled.js';

var OnOffToggle = function OnOffToggle(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onToggle = _ref.onToggle,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 64 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 28 : _ref$height,
    _ref$activeText = _ref.activeText,
    activeText = _ref$activeText === void 0 ? "ON" : _ref$activeText,
    _ref$inactiveText = _ref.inactiveText,
    inactiveText = _ref$inactiveText === void 0 ? "OFF" : _ref$inactiveText,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var handleClick = !disabled && typeof onToggle === "function" ? onToggle : function () {
    return null;
  };
  return /*#__PURE__*/React__default.createElement(ToggleWrapper, {
    checked: checked,
    containerWidth: width,
    containerHeight: height
  }, /*#__PURE__*/React__default.createElement(StyledBG, null, /*#__PURE__*/React__default.createElement(StyledLeft, null, activeText), /*#__PURE__*/React__default.createElement(StyledRight, null, inactiveText)), /*#__PURE__*/React__default.createElement(StyledHandle, null), /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: function onChange() {
      return handleClick(!checked);
    },
    disabled: disabled
  }));
};
OnOffToggle.displayName = "OnOffToggle";
OnOffToggle.propTypes = {
  checked: PropTypes.bool,
  onToggle: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  activeText: PropTypes.string,
  inactiveText: PropTypes.string,
  disabled: PropTypes.bool
};

export { OnOffToggle as default };
